<template>
  <v-container v-if="selectedPersonal">
    <v-row justify="center">
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            <v-btn text @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
              Volver
            </v-btn>
          </v-col>
          <v-col cols="8">
            <personal-info-card-component :personal="selectedPersonal"></personal-info-card-component>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="5">
        <v-card class="card">
          <v-card-title class="font-weight-bold justify-center">Registro de trámite administrativo</v-card-title>
          <v-card-text>
            <v-container>
              <v-row align="center">
                <v-col cols="4" align="center">
                  <v-progress-circular :value="activeStep * 50" v-bind="circularProgressProps"></v-progress-circular>
                </v-col>
                <v-col cols="8">
                  <div class="text-caption step-label">PASO {{ activeStep }}</div>
                  <div class="text-subtitle-1 font-weight-bold step-title">{{ activeStepTitle }}</div>
                  <a class="text-decoration-none back-link" v-show="activeStep != 1" v-on:click="activeStep--"
                    >Volver al paso anterior</a
                  >
                </v-col>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <transition name="fade" mode="out-in">
                  <v-col cols="12" v-if="activeStep == 1" key="1">
                    <v-row align="center">
                      <v-col cols="12">
                        <v-select
                          v-model="faltaAdministrativa.fk_idTipoFalta"
                          rounded
                          filled
                          dense
                          color="secondary"
                          background-color="primary"
                          :items="tipoFaltaAdministrativa"
                          item-value="id"
                          item-text="title"
                          item-color="secondary"
                        >
                          <template v-slot:label>Elegir tipo de trámite <span class="red--text">*</span> </template>
                        </v-select>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="12" v-if="activeStep == 2" key="2">
                    <v-form v-model="fechaFaltaForm">
                      <v-row align="center">
                        <template v-if="faltaAdministrativa.fk_idTipoFalta == 1">
                          <v-col cols="12">
                            <v-date-picker
                              v-model="faltaAdministrativa.fechaDesde"
                              locale="es"
                              color="secondary"
                              no-title
                              full-width
                              :rules="required"
                            ></v-date-picker>
                          </v-col>
                        </template>
                        <template v-else>
                          <v-col cols="12">
                            <v-date-picker
                              v-model="fechaArresto"
                              locale="es"
                              color="secondary"
                              no-title
                              full-width
                              :rules="required"
                              range
                            ></v-date-picker>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :value="this.fechaInicio"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              :rules="required"
                            >
                              <template v-slot:label>Desde <span class="red--text">*</span> </template>
                            </v-text-field>
                          </v-col>
                          <v-col cols="6">
                            <v-text-field
                              :value="this.fechaFin"
                              rounded
                              filled
                              dense
                              background-color="primary"
                              color="secondary"
                              :rules="required"
                            >
                              <template v-slot:label>Hasta <span class="red--text">*</span> </template>
                            </v-text-field>
                          </v-col>
                        </template>
                      </v-row>
                    </v-form>
                  </v-col>
                  <v-col cols="12" v-if="activeStep == 3" key="3">
                    <v-form v-model="arrestoForm">
                      <v-row>
                        <v-col cols="12">
                          <v-autocomplete
                            v-model="faltaAdministrativa.fk_idPersonalEmisor"
                            :label="personalArrestoLabel"
                            placeholder="Personal que autoriza"
                            :items="filteredPersonal"
                            item-value="idPersonal"
                            item-text="CUIP"
                            background-color="primary"
                            color="secondary"
                            rounded
                            filled
                            clearable
                          >
                            <template v-slot:item="{ item }">
                              <v-list-item-avatar color="accent" class="headline font-weight-light white--text">
                                <v-icon color="white">mdi-police-badge</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title class="font-weight-bold">{{
                                  item.apaterno + ' ' + item.amaterno + ' ' + item.nombre + ' ' + item.segundoNombre
                                }}</v-list-item-title>
                                <v-list-item-subtitle>{{ item.CUIP }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                            <template v-slot:no-data>
                              <v-container v-if="personal.length == 0">
                                <v-row>
                                  <v-col cols="12" align="center">
                                    <v-progress-circular indeterminate color="accent"></v-progress-circular>
                                    <div class="text-caption font-weight-bold mt-4">
                                      Cargando datos. Por favor, espere...
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-container>
                            </template>
                          </v-autocomplete>
                          <v-textarea
                            no-resize
                            rows="3"
                            color="secondary"
                            background-color="primary"
                            v-model="faltaAdministrativa.motivo"
                            rounded
                            filled
                            dense
                            :rules="required"
                          >
                            <template v-slot:label>Detalles u observaciones <span class="red--text">*</span> </template>
                          </v-textarea>
                        </v-col>
                        <v-col cols="8">
                          <v-file-input
                            v-model="faltaAdministrativa.file"
                            label="Oficio adjunto"
                            rounded
                            filled
                            background-color="primary"
                            color="secondary"
                            dense
                          ></v-file-input>
                        </v-col>
                        <v-col cols="4">
                          <v-text-field
                            label="No. de oficio"
                            v-model="faltaAdministrativa.numeroOficio"
                            background-color="primary"
                            color="secondary"
                            rounded
                            filled
                            dense
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-col>
                </transition>
              </v-row>
            </v-container>
            <v-container>
              <v-row>
                <v-col md="12" align="center">
                  <v-btn color="error" text class="px-8 mx-4" v-on:click="$router.go(-1)">Cancelar</v-btn>
                  <v-btn
                    class="px-8 mx-4"
                    color="secondary"
                    v-on:click="activeStepButtonHandler"
                    :loading="loading"
                    :disabled="!validActiveStep || loading"
                    >{{ activeStepButtonLabel }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  cardFormColsProps,
  cardProps,
  cardTitleProps,
  circularProgressProps,
  textInputProps,
} from '../../components/props/props'
import moment from 'moment'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PersonalInfoCardComponent from '../../components/PersonalInfoCardComponent.vue'

export default {
  components: {
    PersonalInfoCardComponent,
  },

  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_PERSONAL_FOTO_CUIP(this.id)
    await this.fetchTipoFaltaAdministrativa()
    await this.fetchMotivoFaltaAdministrativa()
  },

  data() {
    return {
      cardFormColsProps,
      cardProps,
      cardTitleProps,
      circularProgressProps,
      textInputProps,

      activeStep: 1,
      loading: false,
      fechaArresto: [],
      fechaFaltaForm: false,
      arrestoForm: false,
      cuipArresto: '',
      cuipArrestado: '',

      faltaAdministrativa: {
        idPersonal: this.id,
        fk_idTipoFalta: null,
        fk_idCatMotivo: 1,
        fk_idPersonalEmisor: null,
        motivo: '',
        fechaDesde: null,
        fechaHasta: null,
        adjunto: null,
        file: null,
        numeroOficio: '',
      },

      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonal',
      selectedPersonal: 'getPersonalFotoCuip',
    }),

    ...mapGetters('tipoFaltaAdministrativa', {
      tipoFaltaAdministrativa: 'getTipoFaltaAdministrativa',
    }),

    ...mapGetters('motivoFaltaAdministrativa', {
      motivoFaltaAdministrativa: 'getMotivoFaltaAdministrativa',
    }),

    filteredPersonal: function () {
      if (this.faltaAdministrativa.fk_idTipoFalta == 2) {
        return this.personal.filter((personal) => {
          return personal.fk_idPuestoDependencia == 2 || personal.fk_idPuestoDependencia == 3
        })
      } else return this.personal
    },

    activeStepTitle: function () {
      switch (this.activeStep) {
        case 1:
          return 'Tipo de trámite'
        case 2:
          return 'Fecha'
        case 3:
          return 'Información principal'
      }
    },

    personalArrestoLabel: function () {
      switch (this.faltaAdministrativa.fk_idTipoFalta) {
        case 1:
          return '¿Quién sanciona?'
        case 2:
          return '¿Quién arrestó?'
      }
    },

    validActiveStep: function () {
      switch (this.activeStep) {
        case 1:
          if (this.faltaAdministrativa.fk_idTipoFalta) {
            return true
          } else return false
        case 2:
          if (this.faltaAdministrativa.fk_idTipoFalta == 1) {
            if (this.faltaAdministrativa.fechaDesde) {
              return true
            } else return false
          } else {
            if (this.fechaFaltaForm) {
              return true
            } else return false
          }

        case 3:
          if (this.arrestoForm) {
            return true
          } else return false
      }
    },

    activeStepButtonLabel: function () {
      if (this.activeStep < 3) {
        return 'Siguiente paso'
      } else {
        return 'Registrar'
      }
    },

    fechaInicio: function () {
      if (this.fechaArresto[0]) {
        if (moment(this.fechaArresto[1]).isBefore(this.fechaArresto[0])) {
          return moment(this.fechaArresto[1]).format(this.API_DATE_FORMAT)
        } else return moment(this.fechaArresto[0]).format(this.API_DATE_FORMAT)
      }
    },

    fechaFin: function () {
      if (this.fechaArresto[1]) {
        if (moment(this.fechaArresto[1]).isAfter(this.fechaArresto[0])) {
          return moment(this.fechaArresto[1]).format(this.API_DATE_FORMAT)
        } else return moment(this.fechaArresto[0]).format(this.API_DATE_FORMAT)
      }
    },

    isRangeDate: function () {
      if (this.faltaAdministrativa.fk_idTipoFalta == 1) {
        return false
      } else return true
    },
  },

  methods: {
    ...mapActions('tipoFaltaAdministrativa', ['fetchTipoFaltaAdministrativa']),
    ...mapActions('motivoFaltaAdministrativa', ['fetchMotivoFaltaAdministrativa']),
    ...mapActions('faltasAdministrativas', ['saveFaltaAdministrativa']),
    ...mapMutations('personal', ['SET_PERSONAL_FOTO_CUIP']),

    activeStepButtonHandler: async function () {
      if (this.activeStep < 3) {
        this.activeStep++
      } else {
        this.loading = true
        if (this.faltaAdministrativa.fk_idTipoFalta != 1) {
          this.faltaAdministrativa.fechaDesde = this.fechaArresto[0]
          this.faltaAdministrativa.fechaHasta = this.fechaArresto[1]
        }

        this.faltaAdministrativa.fechaDesde = moment(this.faltaAdministrativa.fechaDesde).format(this.API_DATE_FORMAT)

        if (this.faltaAdministrativa.fechaHasta) {
          this.faltaAdministrativa.fechaHasta = moment(this.faltaAdministrativa.fechaHasta).format(this.API_DATE_FORMAT)
        }

        this.faltaAdministrativa.adjunto = this.faltaAdministrativa.file.name

        await this.saveFaltaAdministrativa(this.faltaAdministrativa)

        this.$router.go(-1)
      }
    },
  },
}
</script>

<style scoped>
/* Estilos modernos para Registrar Boleta */
.card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;
  animation: fadeInUp 0.6s ease-out !important;
}

.card::v-deep .v-card__title {
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.15) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  color: #e0e0e0 !important;
}

.card::v-deep .v-card__text {
  padding: 24px !important;
  background: transparent !important;
}

/* Labels personalizados */
.step-label {
  color: rgba(224, 224, 224, 0.7) !important;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600 !important;
}

.step-title {
  color: var(--v-secondary-base) !important;
  font-size: 1.1rem !important;
  margin-top: 4px;
}

.back-link {
  color: var(--v-secondary-base) !important;
  cursor: pointer;
  font-size: 0.875rem;
  transition: all 0.3s ease;
}

.back-link:hover {
  color: var(--v-secondary-lighten1) !important;
  text-decoration: underline !important;
}

/* Botones modernos */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative !important;
  overflow: hidden !important;
}

::v-deep .v-btn:hover:not(:disabled):not(.v-btn--text) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

::v-deep .v-btn.secondary:not(.v-btn--text) {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb), 0.4) !important;
}

::v-deep .v-btn.error:not(.v-btn--text) {
  background: linear-gradient(135deg, #fc5c65 0%, #eb3b5a 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(252, 92, 101, 0.4) !important;
}

::v-deep .v-btn--text {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-btn--text:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease !important;
  color: inherit !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.1) !important;
}

/* Progress circular */
::v-deep .v-progress-circular {
  transition: all 0.3s ease;
}

::v-deep .v-progress-circular__overlay {
  stroke: var(--v-secondary-base) !important;
  filter: drop-shadow(0 4px 12px rgba(var(--v-secondary-base-rgb), 0.6));
}

/* Textos */
.text-caption,
.text-subtitle-1 {
  color: #e0e0e0 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.secondary--text {
  color: var(--v-secondary-base) !important;
  transition: all 0.3s ease;
}

.secondary--text:hover {
  color: var(--v-secondary-lighten1) !important;
  text-decoration: underline !important;
}

/* Input fields */
::v-deep .v-text-field.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .v-select.v-text-field--filled > .v-input__control > .v-input__slot,
::v-deep .v-autocomplete.v-text-field--filled > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field.v-text-field--filled:hover > .v-input__control > .v-input__slot,
::v-deep .v-select.v-text-field--filled:hover > .v-input__control > .v-input__slot,
::v-deep .v-autocomplete.v-text-field--filled:hover > .v-input__control > .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .v-input--is-focused.v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

::v-deep .v-text-field--filled .v-text-field__slot input,
::v-deep .v-select--is-menu-active input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field--filled .v-label,
::v-deep .v-select .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-select__selection,
::v-deep .v-select__selection-text {
  color: #e0e0e0 !important;
}

::v-deep .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

::v-deep .v-input--is-focused .v-icon {
  color: var(--v-secondary-base) !important;
}

/* Date Picker */
::v-deep .v-date-picker-header {
  background: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

::v-deep .v-date-picker-table {
  background: transparent !important;
}

::v-deep .v-date-picker-table .v-btn {
  color: #e0e0e0 !important;
}

::v-deep .v-date-picker-table .v-btn--active {
  background: var(--v-secondary-base) !important;
  color: #ffffff !important;
}

/* File Input */
::v-deep .v-file-input .v-input__prepend-outer,
::v-deep .v-file-input .v-input__append-outer {
  margin-top: 8px;
}

::v-deep .v-file-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.6) !important;
}

/* List Items (Autocomplete) */
::v-deep .v-list {
  background: rgba(26, 38, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border-radius: 12px;
}

::v-deep .v-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle {
  color: #e0e0e0 !important;
}

::v-deep .v-list-item__avatar {
  border: 2px solid rgba(var(--v-secondary-base-rgb), 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover .v-list-item__avatar {
  border-color: var(--v-secondary-base);
  box-shadow: 0 4px 12px rgba(var(--v-secondary-base-rgb), 0.4);
}

/* Divider */
::v-deep .v-divider {
  border-color: rgba(var(--v-secondary-base-rgb), 0.2) !important;
}

/* Transiciones */
.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}

/* Animación de entrada */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}
</style>
